import apiFetch from '@wordpress/api-fetch'
import { WP_API_BASE } from 'scripts/shared/constants'

// redirect the user via the /login/ path if already logged-in at shopware
const maybeDoLoginRedirect = async () => {
  const { wpLoginStatus, swLoginStatus } = await apiFetch({
    path: `${WP_API_BASE}/login-statuses`,
  })
  console.log({ wpLoginStatus, swLoginStatus })
  if (wpLoginStatus === false && swLoginStatus === true) {
    window.location.replace('/login/')
  }
}

document.addEventListener('DOMContentLoaded', maybeDoLoginRedirect)
